{
    "alerts": {
        "AN_ERROR_OCCURRED": "Ocorreu um erro. Por favor, tente novamente.",
        "ANCHOR_TAB_STRING_NOT_FOUND": "Cada signatário deve assinar pelo menos um documento.",
        "DUPLICATE_SIGNER_ERROR": "Os signatários duplicados devem ter a mesma opção de assinatura.",
        "DUPLICATE_EMAIL_MOBILE_SIGNER_ERROR": "O e-mail e o telemóvel de cada interveniente devem ser únicos e não podem repetir-se, exceto para CB/SC ou assinatura por procuração. Nesse caso, por favor, marque esta caixa.",
        "DUPLICATE_EMAIL_MOBILE_SIGNER_LEGAL_COMPLIANCE": "Ao marcar a caixa para casos de CB/SC ou assinatura por procuração, confirma que não se trata de uma usurpação de identidade por parte de qualquer interveniente, com as implicações legais correspondentes.",
        "EMAIL_AND_PHONE_MANDATORY": "Todos os signatários devem ter um endereço de e-mail e um número de telemóvel.",
        "EXCLUDE_ALFA_CASE_STATUS_ERROR_MESSAGE": "Não é possível criar um envelope para esta proposta porque não foi enviada para crédito.",
        "GENERIC_ERROR": "A criação do envelope falhou devido a um erro desconhecido.",
        "GUARANTOR_WARNING_MESSAGE": "Os pacotes que incluem garantes não estão autorizados para Diseño.",
        "INVALID_EMAIL_ADDRESS_FOR_RECIPIENT": "O endereço de e-mail fornecido para o(s) signatário(s) não é válido.",
        "MANDATORY_FIELD_FOR_SIGNER_ERROR": "Todos os signatários devem ter um endereço de e-mail e um número de telemóvel.",
        "NO_ACCESS_TO_PROPOSAL_TRACKING_OR_ESIGN": "O seu utilizador não tem acesso aos módulos Gestão de Propostas ou Assinatura Eletrónica.",
        "NO_DOCUMENT_SELECTED": "Selecione pelo menos um documento.",
        "NO_ENVELOPE_FOUND": "Não foi encontrado nenhum envelope para a proposta.",
        "NO_MODULE_ASSIGNED": "Nenhum módulo atribuído",
        "NO_PROPOSALS_AVAILABLE_FOR_GIVEN_SEARCH_CRITERIA": "Não há propostas disponíveis para os critérios de pesquisa indicados.",
        "NO_PROPOSALS_AVAILABLE_FOR_GIVEN_SEARCH_CRITERIA_CLICK_CLEAR": "Não há propostas disponíveis para os critérios de pesquisa indicados. Clique no botão LIMPAR para ver todos os registos.",
        "NO_RESULTS_FOUND": "Não foram encontrados resultados.",
        "NO_SIGNED_DOCUMENTS_AVAILABLE": "Não há documentos disponíveis para este envelope.",
        "NO_SIGNER_DOCUMENT_SELECTED_ACTION": "Por favor, selecione pelo menos um documento e um signatário para criar um envelope.",
        "NO_SIGNER_OR_DOCUMENT_SELECTED": "Nenhum signatário/documento selecionado",
        "NO_SIGNER_SELECTED": "Por favor, selecione pelo menos um signatário.",
        "SEARCH_FOR_A_PROPOSAL_TO_CONTINUE": "Pesquise uma proposta para continuar.",
        "START_DATE_WARNING_MESSAGE": "A data de início deste contrato é anterior à sua assinatura, o que o tornaria sem efeito. Verifique a data e certifique-se de que a assinatura é anterior ou igual à data de início do contrato.",
        "INVALID_PRODUCT_WARNING": "A assinatura eletrónica não está disponível para arrendamento e aluguer de produtos."
    },
    "docusignErrorMessages": {
        "ANCHOR_TAB_STRING_NOT_FOUND": "O ponto de assinatura não foi encontrado no documento.",
        "INVALID_EMAIL_ADDRESS": "Endereço de e-mail inválido.",
        "INVALID_EMAIL_ADDRESS_FOR_RECIPIENT": "O endereço de e-mail do destinatário não é válido.",
        "PHONE_NUMBER_INVALID": "O número de telefone não é válido."
    },
    "labels": {
        "ACTION": "Ação",
        "ADD": "Adicionar",
        "ADD_NEW_SIGNER": "Adicionar novo signatário",
        "ADD_NEXT": "Adicionar seguinte",
        "ADD_SIGNER": "Adicionar signatário",
        "ADMIN_UTILITY": "Admin Utility",
        "APPROVED": "Aprovado",
        "APPROVED_WITH_CONDITIONS": "Aprovada com condições",
        "ASSOCIATE": "Cliente",
        "ASSOCIATED_PARTIES": "Cliente",
        "AUTO_APPROVED": "Aprovada automaticamente",
        "AWAITING_FURTHER_INFORMATION_DOCUMENTS": "Documentação pendente",
        "BACK_TO_DASHBOARD": "Voltar ao início",
        "BULK_EREGISTRY_UTILITY": "Processamento massivo de E-Registo",
        "BUNDLE": "Proposta",
        "CLEAR": "Limpar",
        "CO-BORROWER": "Segundo Cliente",
        "COMBINED": "Conjunto",
        "COMPLETED": "Concluído",
        "CONTRACT_PAID_OFF": "Contrato pago",
        "COUNTRY": "País",
        "CREATE_ENVELOPE": "Criar Envelope",
        "CREATED": "Criado",
        "CREATED_DATE": "Data de criação",
        "CREDIT_DECISION_ROUTED_FOR_MANUAL_REVIEW": "Proposta enviada para revisão manual",
        "DEALER": "Fornecedor",
        "DEALER_REFERENCE": "Referência do fornecedor",
        "DEALERSHIP_NAME": "Fornecedor",
        "DECLINED": "Recusado",
        "DECLINED_DATE": "Data de recusa",
        "DECLINED_REASON": "Motivo da recusa",
        "DELETED": "Eliminado",
        "DELIVERED": "Entregue",
        "DOCUMENT_NAME": "Nome do documento",
        "DOCUMENTS": "Documentos",
        "DOCUMENTS_SELECTED": "Documentos selecionados",
        "DOWNLOAD": "Descarregar",
        "E_SIGNATURE": "Assinatura Digital",
        "E_SIGNATURE_DASHBOARD": "Assinatura Digital - Página Inicial",
        "EMAIL": "E-mail",
        "ENVELOPE_ID": "Número de Identificação do envelope",
        "ENVELOPE_REVIEW": "Revisão do Envelope",
        "E-REGISTRY_DOWNLOAD": "Registo",
        "EXAMPLE_PHONE_NUMBER": "Ex. +351 123456789",
        "EXPIRED": "Expirado",
        "FETCHING_DOCUMENTS_FOR": "A obter documentos para",
        "GERMANY": "Alemanha",
        "GET_STATUS": "Atualizar estado",
        "GUARANTOR": "Garante",
        "HI": "Olá",
        "ICS_REFERENCE": "Número de contrato",
        "ISD_CODE_IS_REQUIRED": "O prefixo do país é obrigatório",
        "JDF_SIGNER": "Signatário JDF",
        "MATURITY_DATE": "Data de vencimento",
        "MERGER_AND_ACQUISITION": "Fusões e Aquisições",
        "MOBILE": "Telemóvel",
        "NAME": "Nome",
        "NO_DECLINING_REASON_PROVIDED": "Não foi fornecido o motivo da recusa",
        "NOT_AVAILABLE": "Não disponível",
        "NOT_SIGNED": "Não assinado",
        "NOT_VIEWED": "Não visualizado",
        "OF": "de",
        "ON_DEMAND": "A pedido",
        "OPTION": "Opção",
        "OPTIONS": "Opções",
        "ORDER": "Ordem",
        "PRIMARY": "Cliente",
        "PRIMARY_CUSTOMER": "Nome do Cliente",
        "PROCESSING": "Em processamento",
        "PRODUCT": "Produto",
        "PROPOSAL": "Proposta",
        "PROPOSAL_DETAILS": "Detalhes da proposta",
        "PROPOSAL_TRACKING": "Gestão de Propostas",
        "PROPOSED": "Proposto",
        "QUOTE": "Estrutura Financeira",
        "QUOTE_STATUS": "Estado",
        "REVIEW_MESSAGE_DETAILS_CANNOT_UPDATE": "c. Estes dados não podem ser atualizados depois de o envelope ser enviado.",
        "REVIEW_MESSAGE_ISD_CODE": "b. O número de telemóvel deve incluir o prefixo do país para todos os signatários. Exemplo: +351 123456789",
        "REVIEW_MESSAGE_OTP": "a. Cada signatário será autenticado através de uma palavra-passe de utilização única (OTP) enviada para o número de telemóvel indicado abaixo.",
        "ROLE": "Ordem",
        "SALESPERSON": "Vendedor",
        "SAVE_&_ADD_NEXT_SIGNER": "Guardar e adicionar o signatário seguinte",
        "SAVE_SIGNER": "Guardar signatário",
        "SEARCH": "Pesquisar",
        "SELECT_DOCUMENTS": "Seleção de documentos",
        "SELECTED_DOCUMENTS": "Documentos no envelope",
        "SELECT_THIRD_PARTY": "Selecionar Interveniente associado",
        "SEND_ENVELOPE": "Enviar envelope",
        "SENDING_ENVELOPE": "A enviar envelope",
        "SENT": "Enviado",
        "SENT_/_VIEWED": "Enviado / Visualizado",
        "SENT_DATE": "Data de envio",
        "SEPARATE": "Separado",
        "SIGN_BY_EMAIL": "Assinar por e-mail",
        "SIGN_NOW": "Assinar agora",
        "SIGNED": "Assinado",
        "SIGNED_DATE": "Data de assinatura",
        "SIGNER": "Signatário",
        "SIGNERS": "Signatários",
        "SIGNING_OPTION": "Opção de assinatura",
        "SIGNING_ORDER": "Ordem de assinatura",
        "SIGNING_ORDER_PREVIEW": "Pré-visualização da ordem de assinatura",
        "SIGNING_STATUS": "Estado da assinatura",
        "PORTUGAL": "Portugal",
        "SPAIN": "Espanha",
        "START_DATE": "Data de Início",
        "STATUS": "Estado",
        "STATUS_DATE": "Data de estado",
        "SUBMITTED": "Submetido",
        "TEMPLATE": "Modelo",
        "THIRD_PARTY": "Interveniente associado",
        "UNDELIVERABLE": "Não entregue",
        "UNITED_KINGDOM": "Reino Unido",
        "UPDATING_STATUS": "A atualizar estado",
        "VIEWED": "Visualizado",
        "VIEWED_DATE": "Data de visualização",
        "VOIDED": "Anulado",
        "WITHDRAWN": "Retirado",
        "PRIMARY_QUOTE": "Proposta processada",
        "ENVELOPE_SENT_UNDER_PROCESS": "O envelope foi enviado. Por favor, aguarde até que o processo seja concluído.",
        "ENVELOPE_SUCCESSFULLY_SENT": "O envelope foi enviado com sucesso",
        "ADD_PROXY": "Adicionar representante legal",
        "PROXY": "Representantes legais",
        "ADD_NEW_PROXY": "Adicionar novo representante LEGAL",
        "you can only assign": "Só pode atribuir",
        "representatives to the": "representantes no máximo à"
    },
    "messages": {
        "BUNDLE_NUMBER_NOT_FOUND": "Não foi encontrado nenhum resultado porque não existem estruturas financeiras associadas a este número de proposta.",
        "CREATE_ON_DEMAND_SIGNER_FOR_ASSOCIATE": "Por favor, crie este signatário como um signatário a pedido.",
        "DOCUMENT_DOWNLOAD_FAILED": "A transferência do documento a partir do S3 falhou.",
        "ICS_NUMBER_NOT_FOUND": "Não foi encontrado nenhum resultado porque não existem estruturas financeiras associadas a este número de contrato.",
        "INVALID_BUNDLE_NUMBER": "O número de proposta introduzido não é válido. Por favor, introduza um válido e tente novamente.",
        "INVALID_ICS_NUMBER": "O número de contrato fornecido não é válido. Por favor, introduza um válido e tente novamente.",
        "INVALID_PRIMARY_CUSTOMER": "O nome do cliente fornecido não é válido. Por favor, introduza um válido e tente novamente.",
        "INVALID_QUOTE_NUMBER": "O número de estrutura financeira introduzido não é válido. Por favor, introduza um válido e tente novamente.",
        "PRIMARY_CUSTOMER_NOT_FOUND": "Não foi encontrado nenhum resultado porque o cliente não existe no sistema.",
        "QUOTE_NUMBER_NOT_FOUND": "Não foi encontrado nenhum resultado porque o número da proposta e o da estrutura financeira não estão relacionados."
    },
    "products": {
        "DPFR_24_MONTH_LOAN_STOCK_DE": "DPFR - 24 month Loan Stock DE",
        "DPFR_LOAN_DE": "DPFR - Loan DE",
        "DPFR_LOAN_STOCK_DE": "DPFR - Loan Stock DE",
        "DPFR_NON_FULL_PAYOUT_LEASE_DE": "DPFR - Non Full Payout Lease DE",
        "DPFR_OPERATING_LEASE_DE": "Operating Lease DE",
        "LOAN_DE": "Loan DE",
        "NON_FULL_PAYOUT_LEASE_DE": "Non Full Payout Lease DE",
        "OPERATING_LEASE_DE": "Operating Lease DE"
    }
}
